import type {PublicMethodUtils} from '@wix/document-services-types'
import type {SectionOrderPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<SectionOrderPublicAPI> {
    const {
        extensionPublicAPI: {dataManipulation, getter}
    } = publicMethodUtils

    return {
        methods: {
            components: {
                responsiveLayout: {
                    reorderGridPageSection: dataManipulation('components.responsiveLayout.reorderGridPageSection'),
                    reorderGridPageSections: dataManipulation('components.responsiveLayout.reorderGridPageSections'),
                    isGridPageChildrenOrderValid: getter('components.responsiveLayout.isGridPageChildrenOrderValid')
                }
            }
        }
    }
}
